module.exports = __webpack_public_path__ + "img/63.4.NH3-N.5766e4f4.png";